import { jsx, css } from '@emotion/react';
import { useState } from 'react';
import { Provider } from 'react-redux';

import CTAButton from './CTAButton';
import Modal from './Modal';
import Splash from './Splash';
import { store } from './Store';

const basicFormStyles = css``;

const buttonContainer = css`
  margin: 0 auto;
`;

const HVACSplash = () => {
  const [modalOpen, setModal] = useState(false);

  return (
    <Provider store={store}>
      <Splash>
        <h3>CONTRACTORS: FIND THE OPPORTUNITIES YOU ARE MISSING</h3>
        <p>Join our mailing list to get business-building ideas delivered straight to your inbox.</p>
        <div css={buttonContainer}>
          <CTAButton href="https://owenscorning.powerappsportals.com/retrofit-subscribe/" text="Subscribe" />
        </div>
      </Splash>
    </Provider>
  );
};

export default HVACSplash;
